// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"3a0d85ac","425":"004c63d0","510":"acf6ab00","532":"414d80e7","633":"3aecf0ea","634":"aab2c08c","922":"9ff570e5","937":"a34545bd","972":"9afc9714"}[chunkId] + ".chunk.js";
};